import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';

export function opacity(speed: string) {
    return trigger('opacity', [
        state('visible', style({
            'opacity': '1',
        })),
        state('hidden', style({
            'opacity': '0'
        })),
        transition('visible => hidden', [
            animate(speed)
        ]),
        transition('hidden => visible', [
            animate(speed)
        ])
    ]);
}

export function height(speed: string) {
    return trigger('height', [
        state('opened', style({
            'max-height': '*',
        })),
        state('closed', style({
            'max-height': '0px'
        })),
        transition('opened => closed', [
            animate(speed)
        ]),
        transition('closed => opened', [
            animate(speed)
        ])
    ]);
}

export function rotate(speed: string, rot: string) {
    return trigger('rotate', [
        state('inactive', style({
            'transform': 'rotate(0deg)'
        })),
        state('active', style({
            'transform': `rotate(${rot})`
        })),
        transition('inactive => active', [
            animate(speed)
        ]),
        transition('active => inactive', [
            animate(speed)
        ])
    ]);
}
